const ULTIMO_PEDIDO_KEY = "mitico_ultimo_pedido_productos";

export const guardarUltimoPedidoCliente = (productos = []) => {
  try {
    if (!Array.isArray(productos) || productos.length === 0) {
      return;
    }

    const productosIds = productos
      .map((producto) => producto?.id || producto?.productoId)
      .filter(Boolean);

    const productosIdsUnicos = Array.from(new Set(productosIds));

    if (productosIdsUnicos.length === 0) {
      return;
    }

    const ultimoPedido = {
      fecha: new Date().toISOString(),
      productosIds: productosIdsUnicos,
    };

    localStorage.setItem(ULTIMO_PEDIDO_KEY, JSON.stringify(ultimoPedido));
  } catch (error) {
    console.error("Error guardando último pedido:", error);
  }
};

export const leerUltimoPedidoCliente = () => {
  try {
    const ultimoPedidoGuardado = localStorage.getItem(ULTIMO_PEDIDO_KEY);

    if (!ultimoPedidoGuardado) {
      return {
        fecha: null,
        productosIds: [],
      };
    }

    const ultimoPedido = JSON.parse(ultimoPedidoGuardado);

    if (!ultimoPedido || !Array.isArray(ultimoPedido.productosIds)) {
      return {
        fecha: null,
        productosIds: [],
      };
    }

    return {
      fecha: ultimoPedido.fecha || null,
      productosIds: ultimoPedido.productosIds.filter(Boolean),
    };
  } catch (error) {
    console.error("Error leyendo último pedido:", error);

    return {
      fecha: null,
      productosIds: [],
    };
  }
};
